interface LinkProps extends React.HTMLProps<HTMLAnchorElement> {
    newTab?: boolean;
};

const Link: React.FC<LinkProps> = (props) => {
    const {
        newTab,
        children,
        style,
        ...otherProps
    } = props;

    const newTabProps = newTab ? {
        target: '_blank',
        rel: 'noopener noreferrer'
    } : {};

    const componentStyle = {
        fontSize: '18px',
        color: '#101720',
        textDecoration: 'none',
        cursor: 'pointer',
        lineHeight: '28px'
    };

    return (
        <a {...otherProps} {...newTabProps} style={{ ...componentStyle, ...style }}>
            {children}
        </a>
    );
};

export default Link;
